import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  SHORTENER_RESOLUTION_CLEAR,
  SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
  SHORTENER_RESOLUTION_DELAY_LINK,
  SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_REQUEST,
} from '../../../actions/actionTypes';

const delayLink = fetchReducerGenerator(
  [
    SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
    SHORTENER_RESOLUTION_CLEAR,
    SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_REQUEST,
  ],
  SHORTENER_RESOLUTION_DELAY_LINK
);

export default delayLink;

export const getShortenerResolutionDelayLinkIsSuccess = state =>
  state.response && state.response.status === HttpStatus.NO_CONTENT.value;
